import { MIN_PREVIEW_IMAGES } from '../../../constants/form';
import { FormValidityObserver as SharedFormValidityObserver } from '../../dapp-form/FormValidityObserver';
import { FORM_ID } from '../constants';

interface FormValidityObserverProps {
  onValidityChange?: (isValid: boolean) => void;
  packageNameValid: boolean;
  packageNameError: string | null;
  isCheckingPackageName: boolean;
  packageName: string;
  hasDappIcon: boolean;
  hasBanner: boolean;
  previewImageCount: number;
}

function hasRequiredUrls(form: HTMLElement) {
  const requiredUrlNames = ['licenseUrl', 'privacyPolicyUrl'] as const;

  return requiredUrlNames.every((name) => {
    const input = form.querySelector(`[name="${name}"]`) as HTMLInputElement;
    return !!input?.value?.trim();
  });
}

export function FormValidityObserver({
  onValidityChange,
  packageNameValid,
  packageNameError,
  isCheckingPackageName,
  packageName,
  hasDappIcon,
  hasBanner,
  previewImageCount,
}: FormValidityObserverProps) {
  const hasPackageName = Boolean(packageName.trim());
  const isPackageNameValid =
    hasPackageName &&
    !isCheckingPackageName &&
    !packageNameError &&
    packageNameValid;

  return (
    <SharedFormValidityObserver
      onValidityChange={onValidityChange}
      isExtraValid={
        isPackageNameValid &&
        hasDappIcon &&
        hasBanner &&
        previewImageCount >= MIN_PREVIEW_IMAGES
      }
      formId={FORM_ID}
      validateForm={hasRequiredUrls}
    />
  );
}
